<template>
  <div>
    <v-btn v-if="isAdd" color="accent" small @click.stop="dialog = !dialog"> add </v-btn>
    <v-btn v-else @click.stop="dialog = !dialog" color="secondary"> edit </v-btn>
    <v-dialog
      v-if="dialog"
      v-model="dialog"
      scrollable
      max-width="500"
      transition="dialog-bottom-transition"
      @click:outside="resetForm"
    >
      <v-card>
        <v-card-title class="grey lighten-4 py-4 title black--text">
          <div>{{ isAdd ? 'Add new' : 'Edit' }} B2B Assessment Package Assignment</div>
          <v-spacer></v-spacer>
          <v-card-actions v-if="!isAdd">
            <v-btn icon @click="deleteB2BAssessmentPackageAssignment"><v-icon color="red">delete</v-icon></v-btn>
          </v-card-actions>
        </v-card-title>
        <v-card-text>
          <v-form v-model="Form.valid" ref="b2bAssessmentPackageAssignmentForm">
            <v-container grid-list-xs :class="$vuetify.breakpoint.mdAndUp ? 'pa-5' : ''">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    label="Package ID"
                    v-model="Form.package_id"
                    @keypress="onlyNumber"
                    :rules="[(v) => !!v || 'Package ID is required']"
                    required
                  />
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Assessment ID"
                    v-model="Form.b2b_assessment_id"
                    @keypress="onlyNumber"
                    :rules="[(v) => !!v || 'Assessment ID is required']"
                    required
                  />
                </v-flex>
                <v-flex xs12>
                  <v-select
                    :items="typeSelect"
                    item-text="text"
                    item-value="value"
                    persistent-hint
                    label="Type"
                    required
                    v-model="Form.type"
                    :rules="[(v) => !!v || 'Type is required']"
                  />
                </v-flex>

                <v-flex>
                  <v-card-actions>
                    <v-btn color="accent" :disabled="!Form.valid" @click="addOrEditB2BAssessmentPackageAssignment">{{
                      isAdd ? 'Create' : 'Update'
                    }}</v-btn>
                  </v-card-actions>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Forms from '../form/form';
import b2bAssessmentPackageAssignmentService from '../services/b2bassessmentpackageassignment';

export default {
  data() {
    return {
      dialog: false,
      assignmentId: null,
      Form: new Forms({
        data: () => ({
          package_id: null,
          b2b_assessment_id: null,
          type: '',
        }),
      }),
      typeSelect: [
        { text: 'BAT12', value: 'bat12' },
        { text: 'CAGE', value: 'cage' },
        { text: 'Other', value: 'other' },
      ],
    };
  },
  props: {
    isAdd: {
      type: Boolean,
      default: true,
    },
    b2bAssessmentPackageAssignment: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    resetForm() {
      this.Form.reset();
    },
    onlyNumber(e) {
      const char = String.fromCharCode(e.keyCode);
      if (!/[0-9]/.test(char)) {
        e.preventDefault();
      }
    },
    fillForm() {
      this.$nextTick(() => {
        this.$refs.b2bAssessmentPackageAssignmentForm.resetValidation();
      });
      this.assignmentId = this.b2bAssessmentPackageAssignment.id;
      this.Form.package_id = this.b2bAssessmentPackageAssignment.package_id;
      this.Form.b2b_assessment_id = this.b2bAssessmentPackageAssignment.b2b_assessment_id;
      this.Form.type = this.b2bAssessmentPackageAssignment.type;
    },

    preparePayload() {
      const payload = {
        package_id: parseInt(this.Form.package_id),
        b2b_assessment_id: parseInt(this.Form.b2b_assessment_id),
        type: this.Form.type,
      };
      return payload;
    },

    async addOrEditB2BAssessmentPackageAssignment() {
      if (this.Form.valid) {
        const payload = this.preparePayload();
        if (this.isAdd) {
          b2bAssessmentPackageAssignmentService
            .createB2BAssessmentPackageAssignment(payload)
            .then(() => {
              this.dialog = false;
              this.resetForm();
              this.$emit('success');
              this.$notify({
                title: 'Success',
                text: 'New B2B assessment package assignment has been added successfully.',
                type: 'success',
              });
            })
            .catch((error) => {
              console.error('Error creating new B2B assessment package assignment:', error);
              this.$notify({
                title: 'Error',
                text: `There was an error adding the new B2B assessment package assignment. Please try again. \n${
                  error.response?.data?.error?.message || error.message
                }`,
                type: 'error',
              });
            });
        } else {
          b2bAssessmentPackageAssignmentService
            .updateB2BAssessmentPackageAssignment(this.assignmentId, payload)
            .then(() => {
              this.dialog = false;
              this.resetForm();
              this.$emit('success');
              this.$notify({
                title: 'Success',
                text: 'B2B assessment package assignment has been updated successfully.',
                type: 'success',
              });
            })
            .catch((error) => {
              console.error('Error updating B2B assessment package assignment:', error);
              this.$notify({
                title: 'Error',
                text: `There was an error updating the B2B assessment package assignment. Please try again. \n${
                  error.response?.data?.error?.message || error.message
                }`,
                type: 'error',
              });
            });
        }
      }
    },
    async deleteB2BAssessmentPackageAssignment() {
      this.$root
        .$confirm(
          'Delete B2B Assessment Package Assignment',
          `Are you sure you want to delete this B2B assessment package assignment? This action cannot be undone.`,
          { color: 'red' }
        )
        .then(async (confirm) => {
          if (confirm) {
            await b2bAssessmentPackageAssignmentService
              .deleteB2BAssessmentPackageAssignment(this.assignmentId)
              .then(() => {
                this.dialog = false;
                this.resetForm();
                this.$emit('success');
                this.$notify({
                  title: 'Success',
                  text: 'B2B assessment package assignment has been deleted successfully.',
                  type: 'success',
                });
              })
              .catch((error) => {
                console.error('Error deleting B2B assessment package assignment:', error);
                this.$notify({
                  title: 'Error',
                  text: 'There was an error deleting the B2B assessment package assignment. Please try again.',
                  type: 'error',
                });
              });
          }
        });
    },
  },
  watch: {
    dialog(val) {
      if (val && !this.isAdd && this.b2bAssessmentPackageAssignment) {
        this.fillForm();
      }
    },
  },
};
</script>
